import React from "react";
import PropTypes from "prop-types";
import { Col, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import { AvForm, AvField } from "availity-reactstrap-validation";

const InvoiceModal = props => {
  const { isOpen, toggle, data, addCampaignFormat } = props;

  const handleValidOrderSubmit = (e, values) => {
    const format = {
      name: values["name"],
      description: values["description"],
    };
    addCampaignFormat(format, data);
  };

  return (
    <Modal isOpen={isOpen} autoFocus={true} centered={true} toggle={toggle}>
      <ModalHeader tag="h4">Add campaign format</ModalHeader>
      <ModalBody>
        <AvForm onValidSubmit={handleValidOrderSubmit}>
          <Row form>
            <Col className="col-12">
              <div className="mb-3">
                <Label>Format name</Label>
                <AvField
                  name="name"
                  type="text"
                  errorMessage="This value is required."
                  validate={{
                    required: { value: true },
                  }}
                />
              </div>
              <div className="mb-3">
                <Label>Description</Label>
                <AvField
                  name="description"
                  type="text"
                  errorMessage="This value is required."
                  validate={{
                    required: { value: false },
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="text-end">
                <button type="submit" className="btn btn-success save-user" onClick={toggle}>
                  Save changes
                </button>
              </div>
            </Col>
          </Row>
        </AvForm>
      </ModalBody>
    </Modal>
  );
};

InvoiceModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  data: PropTypes.any,
  addCampaignFormat: PropTypes.func,
};

export default InvoiceModal;
